import React from 'react';
import SortFilter from './SortFilter';
import { DateFilter } from './DateFilter';
import SortMode from './SortMode';
import ParliamentaryRecordMultipleHierarchy from './ParliamentaryRecordMultipleHierarchy';
import { OutsideCommonFilter, OutsideSearchFilter } from './OutsideFilters';

const FilterTypeRenderer = ({
  type,
  allowedUsers,
  list,
  isExpandedOnAction,
  setExpanded,
  filterProps,
  showMoreOptions,
}) => {
  return (
    <>
      {type === 'search' && <OutsideSearchFilter {...filterProps} isExpanded={isExpandedOnAction} />}
      {type === 'sort' && <SortFilter {...filterProps} notIncludeName setExpanded={setExpanded} />}
      {type === 'date' && <DateFilter {...filterProps} notIncludeName notShowCalendar={!allowedUsers} />}
      {type === 'sortMode' && <SortMode {...filterProps} list={list} notIncludeName />}
      {type === 'parliamentaryRecordMultipleHierarchy' && (
        <ParliamentaryRecordMultipleHierarchy {...filterProps} notIncludeName />
      )}
      {(!type || type === 'membership') && (
        <OutsideCommonFilter
          {...filterProps}
          isExpandedParent={isExpandedOnAction}
          allowedUsers={allowedUsers}
          showMoreOptions={showMoreOptions}
        />
      )}
    </>
  );
};

export default FilterTypeRenderer;
